import { ZonedDateTime } from '@js-joda/core';
import React from 'react';

import { Button } from '#/shared/components/Button';
import { Modal, ModalContent } from '#/shared/components/Modal';

import { DrawnSignatureOnChange } from './types/SignatureInput';
import { SignatureInputDrawCanvas } from './SignatureInputDrawCanvas';

type SignatureInputDrawProps = {
  value?: string;
  signedAt?: ZonedDateTime;
  isError?: boolean;
  onChange: DrawnSignatureOnChange;
};

export function SignatureInputDraw({ value, signedAt, isError, onChange }: Readonly<SignatureInputDrawProps>) {
  const [interimValue, setInterimValue] = React.useState<string | undefined>(value);

  return (
    <Modal
      dialogTriggerElement={<SignatureInputDrawCanvas readOnly value={value} signedAt={signedAt} isError={isError} />}
    >
      {({ close }) => {
        // store updates in the state value
        const handleChange = (e: string | undefined) => setInterimValue(e);

        // close modal and reset state value with original parent value
        const handleCancel = () => {
          setInterimValue(value);
          close();
        };

        // close modal and update the parent value
        const handleSave = () => {
          onChange(interimValue, ZonedDateTime.now());
          close();
        };

        return (
          <ModalContent title={'Signature'} onCancel={handleCancel}>
            {/* 'overflow-y-auto' so the middle section scrolls */}
            <div className="px-24 overflow-y-auto">
              <p className="text-16 text-on-surface-variant pb-8">Sign inside the box</p>

              <div className="rounded-sm border-1 border-outline-l4">
                <SignatureInputDrawCanvas value={interimValue} onChange={handleChange} />
              </div>
            </div>

            <div className="px-24 flex gap-12">
              <Button variant="primaryOutline" size="medium" onPress={handleCancel} className="w-full">
                Cancel
              </Button>
              <Button onPress={handleSave} size="medium" className="w-full">
                Done
              </Button>
            </div>
          </ModalContent>
        );
      }}
    </Modal>
  );
}
